import { ApiImageClient } from "@/api";

async function apiUserGetAccountsProjectNode({ id }: { id: string }) {
  try {
    const result = await ApiImageClient.get(
      `/project-nodes/${id}?populate[0]=steelAssemblyList&populate[1]=workItems.employees&populate[2]=childNodes&populate[3]=parentNode&populate[4]=project`,
    ).then(({ data }) => {
      return data;
    });
    return result;
  } catch (e) {
    console.error("apiUserGetAccountsProjectNode_Error", e);
    return e;
  }
}

async function apiUserGetAccountsProjectNodes() {
  try {
    const result = await ApiImageClient.get(`/project-nodes?populate=*`).then(
      ({ data }) => data,
    );
    return result;
  } catch (e) {
    console.error("apiUserGetAccountsProjectNodes_Error", e);
    return e;
  }
}

interface WorkItem {
  id: string;
  name: string;
  employees: {
    id: string;
    name: string;
    documentId: string;
  }[];
  scanMode: string;
}

interface ProjectNodeData {
  id: string;
  project: string;
  nodeType: string;
  parentNode?: string;
  childNodes?: string[];
  workItems?: WorkItem[];
  steelAssemblyList?: any[];
  steelAssemblyStats?: Record<string, any>;
}

interface ProjectNodeUpdateData {
  name?: string;
  nodeType: string;
  parentNode?: string;
  childNodes?: string[];
  workItems?: any[];
  steelAssemblyList?: any[];
  steelAssemblyStats?: Record<string, any>;
}

async function apiUserPostAccountsProjectNode({
  data,
}: {
  data: ProjectNodeData;
}) {
  try {
    const result = await ApiImageClient.post("/project-nodes", { data }).then(
      ({ data }) => data,
    );
    return result;
  } catch (e) {
    console.error("apiUserPostAccountsProjectNode_Error", e);
    return e;
  }
}

async function apiUserPutAccountsProjectNodes({
  id,
  data,
}: {
  id: string;
  data: ProjectNodeUpdateData;
}) {
  try {
    const result = await ApiImageClient.put(`/project-nodes/${id}`, {
      data,
    }).then(({ data }) => data);
    return result;
  } catch (e) {
    console.error("apiUserPutAccountsProjectNodes_Error", e);
    return e;
  }
}

async function apiUserDeleteAccountsProjectNode({ id }: { id: string }) {
  try {
    const result = await ApiImageClient.delete(
      `/project-nodes/${id}?populate=*`,
    ).then(({ data }) => data);
    return result;
  } catch (e) {
    console.error("apiUserDeleteAccountsProjectNode_Error", e);
    return e;
  }
}

export {
  apiUserPostAccountsProjectNode,
  apiUserPutAccountsProjectNodes,
  apiUserGetAccountsProjectNodes,
  apiUserGetAccountsProjectNode,
  apiUserDeleteAccountsProjectNode,
};
